module.exports = __webpack_public_path__ + "img/island-flying-icon.3fe1db74.svg";